// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__Z5mVy","title":"page_title__xJG91","subtitle":"page_subtitle__i5GZC"};